export const checkIsGuestView = (profile, booking) => {
  if (!!booking?.view_as) {
    // when the booking data comes from BundlesApi, there is a view_as property included
    return booking.view_as === 'GUEST';
  }
  // if not coming from bundles, there are guest/host properties on the booking that can be referenced
  const hostSSOid = booking?.host?.ssoid;
  // defaults to true if not host view
  return hostSSOid !== profile?.SSOid;
};
